import React, { useCallback, useEffect, useState } from "react";
import styles from "./category.module.scss";
import {
  KoForm,
  KoFormBuilder,
  KoLoader,
  KoSelect,
  KoText,
  KoTextArea,
  KoToast,
  Upload
} from "packages";
import ImgCrop from "antd-img-crop";
import KoIcon from "@kwapio/icons";
import { OrdersAPI } from "../../../orders.service";
import { getCookie } from "shared/utils/cookies";


export default function ChildCategoryForm({
  form,
  handleFinish,
  onCategoryChange,
  onSubCategoryChange
}) {
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [subCategoryLoading, setSubCategoryLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  console.log(subCategoryList);

  useEffect(() => {
    setCategoryLoading(true);
    OrdersAPI.getCategory()
      .then((res) => {
        setCategoryList(Array.isArray(res?.categories) ? res.categories : []);
      })
      .finally(() => setCategoryLoading(false));
  }, []);

  useEffect(() => {
    if (!selectedCategoryId) return;
    setSubCategoryLoading(true);
    OrdersAPI.getSubCategory(selectedCategoryId)
      .then((res) => {
        setSubCategoryList(Array.isArray(res?.data) ? res.data : []);
      })
      .finally(() => setSubCategoryLoading(false));
  }, [selectedCategoryId]);

  const normFile = useCallback((e) => {
    if (Array.isArray(e)) return e;
    return e?.fileList || [];
  }, []);

  const beforeUpload = useCallback((file) => {
    const isValidType =
      file.type === "image/jpeg" || file.type === "image/png";

    if (!isValidType) {
      KoToast.error("Only JPG / PNG files are allowed");
      return Upload.LIST_IGNORE;
    }

    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      KoToast.error("Image must be smaller than 2MB");
      return Upload.LIST_IGNORE;
    }

    return true;
  }, []);

  const uploadProps = {
    name: "files",
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    Preview:true,
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },
    maxCount: 1,
    beforeUpload,
    onChange(info) {
      if (info.file.status === "uploading") {
        setUploadLoading(true);
      }

      if (info.file.status === "done") {
        setUploadLoading(false);
        KoToast.success("Image uploaded successfully");
      }

      if (info.file.status === "error") {
        setUploadLoading(false);
        KoToast.error("Image upload failed");
      }
    }
  };

  // ---------------------------------------------------
  // SELECT COMPONENTS
  // ---------------------------------------------------
  const Category = ({ value, onChange }) => (
    <KoSelect
      value={value}
      placeholder="Select Category"
      onChange={(val) => {
        onChange(val);
        setSelectedCategoryId(val);
        onCategoryChange(val);
      }}
      options={categoryList.map((cat) => ({
        label: cat.name,
        value: cat.categoryId
      }))}
      loading={categoryLoading}
    />
  );
  const catlist=[{label:"mobile",value:"scat3a5aeef595"}];

  const SubCategory = ({ value, onChange }) => (
    <KoSelect
      value={value}
      placeholder="Select Sub Category"
      onChange={(val) => {
        onChange(val);
        onSubCategoryChange(val);
      }}
      // options={subCategoryList.map((sub) => ({
      //   label: sub.name,
      //   value: sub.subCategoryId
      // }))}
      options={catlist?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
      loading={subCategoryLoading}
      disabled={!selectedCategoryId}
    />
  );

  const TextArea = ({ value, onChange }) => (
    <KoTextArea value={value} onChange={onChange} showCount maxLength={100} />
  );

  // ---------------------------------------------------
  // FORM META
  // ---------------------------------------------------
  const meta = {
    columns: 4,
    colon: true,
    fields: [
      {
        key: "name",
        label: "Child Category Name",
        colSpan: 4,
        rules: [{ required: true }]
      },
      {
        key: "categoryId",
        label: "Category",
        colSpan: 4,
        widget: Category,
        rules: [{ required: true }]
      },
      {
        key: "subCategoryId",
        label: "Sub Category",
        colSpan: 4,
        widget: SubCategory,
        rules: [{ required: true }]
      },
      {
        key: "description",
        label: "Description",
        colSpan: 4,
        widget: TextArea
      }
    ]
  };

  // ---------------------------------------------------
  // UI
  // ---------------------------------------------------
  return (
    <div className={styles.formWrapper}>
      <KoForm form={form} layout="vertical" onFinish={handleFinish}>

        <KoForm.Item
          name="image"
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <ImgCrop aspect={115 / 25}>
            <Upload
              {...uploadProps}
              listType="picture-card"
              showUploadList={false}
            >
              <div className={styles.dndArea}>
                {uploadLoading && <KoLoader size="small" />}
                <KoIcon name="ImagesOutlined" width={40} height={40} />
                <KoText text="Upload Image" />
              </div>
            </Upload>
          </ImgCrop>
        </KoForm.Item>

        <KoFormBuilder form={form} meta={meta} />
      </KoForm>
    </div>
  );
}
